const normalizeEstadoName = (value = "") =>
  String(value).trim().toLowerCase().replace(/\s+/g, " ");

export const SENT_TO_CLIENT_ESTADO_NAMES = [
  "sent to client",
  "sent to cliente",
  "enviado a cliente",
];

export const findSentToClientEstado = (tiposEstado = []) =>
  tiposEstado.find((est) =>
    SENT_TO_CLIENT_ESTADO_NAMES.includes(normalizeEstadoName(est.ESTADO)),
  ) || null;

export const findSentToClientEstadoId = (tiposEstado = []) =>
  findSentToClientEstado(tiposEstado)?.ID_ESTADO ?? null;

export const SENT_ESTADO_ID = 5;

export const formatEstadoLabel = (estadoName = "") => {
  if (SENT_TO_CLIENT_ESTADO_NAMES.includes(normalizeEstadoName(estadoName))) {
    return "SENT TO CLIENT";
  }
  return estadoName;
};

export const sortTiposEstadoForSelect = (tiposEstado = []) => {
  const sentToClient = findSentToClientEstado(tiposEstado);
  if (!sentToClient) {
    return [...tiposEstado].sort((a, b) => a.ID_ESTADO - b.ID_ESTADO);
  }

  const rest = tiposEstado
    .filter((e) => e.ID_ESTADO !== sentToClient.ID_ESTADO)
    .sort((a, b) => a.ID_ESTADO - b.ID_ESTADO);

  const sentIndex = rest.findIndex(
    (e) =>
      e.ID_ESTADO === SENT_ESTADO_ID ||
      normalizeEstadoName(e.ESTADO) === "sent",
  );

  if (sentIndex === -1) {
    return [...rest, sentToClient];
  }

  return [
    ...rest.slice(0, sentIndex + 1),
    sentToClient,
    ...rest.slice(sentIndex + 1),
  ];
};

export const isSentToClientEstado = (estadoId, tiposEstado = []) =>
  estadoId != null && estadoId === findSentToClientEstadoId(tiposEstado);

/** OK FACTORY / SENT — solo proveedores (China) pueden seleccionarlos. */
export const isChinaOnlyEstado = (estadoId) => estadoId === 3 || estadoId === 5;

/** Estados que un proveedor puede elegir en el select (OK FACTORY, SENT, SENT TO CLIENT). */
export const isProviderSelectableEstado = (estadoId, tiposEstado = []) =>
  isChinaOnlyEstado(estadoId) || isSentToClientEstado(estadoId, tiposEstado);

const normalizeMarcaName = (value = "") =>
  String(value).trim().toUpperCase();

/** Internal destinations (warehouse / SDS) — not "Sent to Client". */
export const isInternalShipmentMarca = (marcaName = "") => {
  const normalized = normalizeMarcaName(marcaName);
  if (!normalized) return false;
  return normalized.includes("STAGE DESIGN") || normalized === "SDS";
};

export const findSdsMarca = (tiposMarcas = []) => {
  const list = Array.isArray(tiposMarcas) ? tiposMarcas : [];
  const exactSds = list.find(
    (m) => normalizeMarcaName(m.MARCA) === "SDS",
  );
  if (exactSds) return exactSds;
  return (
    list.find((m) => isInternalShipmentMarca(m.MARCA)) || null
  );
};

export const findSdsMarcaId = (tiposMarcas = []) =>
  findSdsMarca(tiposMarcas)?.ID_MARCA ?? null;

export const getMarcaNameById = (idMarca, tiposMarcas = []) => {
  const marca = tiposMarcas.find(
    (m) => Number(m.ID_MARCA) === Number(idMarca),
  );
  return marca?.MARCA || "";
};

export const pickLatestMovimiento = (movimientos = []) =>
  [...movimientos]
    .filter(
      (m) =>
        m.FECHA_ENVIO &&
        (m.TIPO_DESTINO || m.ID_Marca || m.ID_CLIENTE || m.CODPROV),
    )
    .sort((a, b) => {
      const ta = new Date(a.FECHA_ENVIO).getTime();
      const tb = new Date(b.FECHA_ENVIO).getTime();
      if (tb !== ta) return tb - ta;
      return (b.ID_MOVIMIENTO || 0) - (a.ID_MOVIMIENTO || 0);
    })[0] || null;

export const shouldSetSentToClientFromMovimientos = (
  movimientos,
  tiposMarcas = [],
) => {
  const latest = pickLatestMovimiento(movimientos);
  if (!latest) return false;

  const tipo = String(latest.TIPO_DESTINO || "").toUpperCase();
  if (tipo === "CLIENTE") return true;
  if (tipo === "PROVEEDOR" || tipo === "INTERNO") return false;

  // Legacy marca-based destination
  const marcaName = getMarcaNameById(latest.ID_Marca, tiposMarcas);
  return marcaName && !isInternalShipmentMarca(marcaName);
};

export const applyMuestraFromMovimientos = ({
  movimientos,
  tiposMarcas,
  sentToClientEstadoId,
  setMuestra,
}) => {
  const fechasValidas = movimientos.map((m) => m.FECHA_ENVIO).filter(Boolean);

  setMuestra((prev) => {
    const next = { ...prev };

    if (fechasValidas.length === 0) {
      next.FECHA_ENVIO = null;
    } else {
      next.FECHA_ENVIO = fechasValidas.sort()[0];
    }

    if (
      sentToClientEstadoId &&
      shouldSetSentToClientFromMovimientos(movimientos, tiposMarcas)
    ) {
      next.ID_ESTADO = sentToClientEstadoId;
    }

    return next;
  });
};
